// extracted by mini-css-extract-plugin
export default {"userId":"UserPaginationSelect_userId__m-f26","userType":"UserPaginationSelect_userType__0mU0+"};